export const Version = { git_commit:"6b6042d9bc5a3f9a60fb9f7bb8f7b2bf4bfb161d.b5" };